import InfoItem from "../../components/forms/InfoItem";

export const LoginInfo = (props) => {
  // console.log(props.inputs);
  return (
    <div className="settings-user-info-box">
      <h3>Informazioni Login</h3>
      {props.inputs.map((input, i) => (
        <InfoItem
          key={`input_${i}`}
          target={input.target}
          type={input.type}
          placeholder={input.placeholder}
          defaultValue={input.defaultValue}
          // error={input.error}
          disabled={props.inputDisabled}
          label={input.label}
          //   handleChangeInput={props.handleChangeInput}
          button={input.button}
          //   handleSubmit={props.handleSubmit}
        />
      ))}
    </div>
  );
};
export default LoginInfo;
